<template>
  <Dialog header="" v-model:visible="displayModal" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }" :modal="true" @after-hide="" :closable="false">
    <template #header>
      <b-container fluid>
        <b-row>
          <b-col>
            <h6 v-if="requestForm.type == 4" class="compo-heading">{{ $t("IssueReturn.title") }}</h6>
            <h6 v-else class="compo-heading">{{ $t("issue.issue") }}</h6>

          </b-col>
          <b-col class="d-flex flex-row-reverse">
            <i class="pi pi-times" @click="goback()"></i>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <b-form @submit.prevent="closeRequestModel()">
      <b-row v-if="showone == 'IndirectIssue'">
        <b-col sm="12" class="w-50">
          <div class="field ms-4">
            <label>{{ $t("Request.requestid") }}</label>
            <p class="common-heading">{{ requestForm.requestId }}</p>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="showone == 'DirectIssue'">
        <b-col sm=" 12" class="w-50">
          <div class="field ms-4">
            <label>{{ $t("issue.issueid") }}</label>
            <p class="common-heading">{{ requestForm.issueId }}</p>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="showone == 'IssueReturn'">
        <b-col sm="12" class="w-50">
          <div class="field ms-4">
            <label>{{ $t("issue.issuereturnid") }}</label>
            <p class="common-heading">{{ requestForm.issueReturnId }}</p>
          </div>
        </b-col>
      </b-row>
      <div class="location-popup-line">
        <b-row class="pb-5 position-relative ms-1">
          <b-col class="pb-4 field">
            <img class="location-popup-icon1" src="../../../../../assets/Img/icons/location.svg" />
            <div class="w-75">
              <!-- {{ requestForm }} -->
              <StoreDropDown :label="$t('Request.fromstore')" v-model="requestForm.FromStoreBrMapId" name="FromStore"
                id="FromStore" :rules="{ required: true }" :required-icon="true" :storeStatus="QueryStringValue1.status"
                :disabled="true" />
            </div>
          </b-col>
        </b-row>
      </div>
      <b-row class="position-relative ms-1">
        <b-col class="field">
          <img class="location-popup-icon2" src="../../../../../assets/Img/icons/location.svg" />
          <div class="w-75 locationpopupposition">
            <StoreDropDown :label="$t('Request.tostore')" v-model="requestForm.ToStoreBrMapId" name="ToStore"
              id="ToStore" :filterId="requestForm.fromStoreId"
              :disabled="(requestForm.type != 2 && requestForm.type != 4) || requestForm.StockOutTMId != 0"
              :storetype="topassStatus()" :tostorefilter="1" :rules="{ required: true }" :required-icon="true"
              :storeStatus="QueryStringValue1.status" />
          </div>
        </b-col>
      </b-row>
      <b-row class="">
        <b-col class="pt-3 field d-flex flex-row-reverse">
          <AddButton class="" btnname="Next" type="submit" />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  PropType,
  computed,
  reactive,
  onMounted,
  watch,
} from "vue";
import AddButton from "../../../../../components/GeneralButtons/AddButton.vue";
import CustomDropdown from "../../../../../components/FormComponents/Dropdown.vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import Tablepage from "../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import { useRoute, useRouter } from "vue-router";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";
import commonservice from "../../../../../modules/Inventory/Service/StoreService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import StoreDropDown from "../../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";
import { debug } from "console";
import { globalCookiesConfig } from "vue3-cookies";

export default defineComponent({
  components: {
    TextField,
    CustomDropdown,
    Tablepage,
    StoreDropDown,
  },

  props: {
    displayModal: {
      type: Boolean,
      default: true,
    },
    showone: {
      type: String,
      default: "",
    },
    storeDetails: {},
  },
  setup(props, { emit }) {
    const router = useRouter();

    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    const route = useRoute();
    const QueryStringValue = useRoute();
    let QueryStringValue1: any = QueryStringValue.query;
    QueryStringValue1 = JSON.parse(QueryStringValue1.data);
    const RequestData: any = reactive({
      fromStore: 0,
      fromOption: [],
      toStore: ref(),
      toOption: [],
      toStoreName: "",
      FromStoreName: "",
    });
    const requestForm = reactive({
      requestId: "",
      fromStoreId: 0,
      FromStoreBrMapId: 0,
      toStoreId: 0,
      ToStoreBrMapId: 0,
      issueId: "",
      issueReturnId: "",
      type: 0,
      StockOutTMId: 0,
      StockInTransId: 0,
    });
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    let usersData;
    onMounted(async () => {
      let SessionUserData = localStorage.getItem("UsersData");
      if (SessionUserData !== null) {
        usersData = JSON.parse(SessionUserData);
      }
    });

    watch(
      () => props.storeDetails,
      (newStoreDetails) => {
        if (newStoreDetails) {
          Object.keys(newStoreDetails).forEach((key) => {
            if (key in requestForm) {
              requestForm[key] = newStoreDetails[key];
            }
          });
        }
      },
      { deep: true, immediate: true }
    );
    const displayModal = ref(true);
    const goback = () => {
      setupHistoryManagement(router, 2);
    };
    function update() {
      debugger;
      console.log(requestForm);
      debugger;
      requestForm.toStoreId = requestForm.ToStoreBrMapId["StoreId"];
      emit("getstorevalue", requestForm);
    }
    const closeRequestModel = handleSubmit((values) => {
      debugger;
      update();
      //  requestForm.StockWOTransTMId
      displayModal.value = false;
    });
    const paramValue = computed(() => {
      return route.query.param as string;
    });
    function passStatus() {
      if (QueryStringValue1.status == "1") {
        return paramValue.value == "DirectIssue" ? 6 : 9;
      } else if (QueryStringValue1.status == "2") {
        return 8;
      } else if (QueryStringValue1.status == "3") {
        return 6;
      }
    }
    function topassStatus() {
      if (QueryStringValue1.status == "1") {
        return paramValue.value == "DirectIssue" ? 6 : 9;
      } else if (QueryStringValue1.status == "2") {
        return 10;
      } else if (QueryStringValue1.status == "3") {
        return 10;
      }
      else if (paramValue.value == "IssueReturn") {
        return 8
      }
    }
    return {
      topassStatus,
      QueryStringValue1,
      passStatus,
      closeRequestModel,
      displayModal,
      requestForm,
      RequestData,
      // LoadToStore,
      // Onchange,
      // onchange2,
      goback,
      // requestCode
    };
  },
});
</script>
<style></style>
